'use client';

import { useEffect } from 'react';
import { datadogRum } from '@datadog/browser-rum';

// Last-resort boundary for errors thrown by the root layout itself (which
// app/(protected)/error.tsx cannot catch). It replaces the root layout, so it
// renders its own <html>/<body> and keeps styling inline.
export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    datadogRum.addError(error, { boundary: 'app/global-error.tsx' });
  }, [error]);

  return (
    <html lang="en">
      <body
        style={{
          fontFamily: 'Roboto, system-ui, sans-serif',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 16,
          minHeight: '100vh',
          margin: 0,
          padding: 16,
          textAlign: 'center',
        }}
      >
        <h2 style={{ margin: 0 }}>Something went wrong</h2>
        <p style={{ margin: 0 }}>Ullr hit an unexpected error. Try again, or reload the page.</p>
        <button
          type="button"
          onClick={reset}
          style={{ padding: '8px 16px', borderRadius: 6, border: '1px solid #ccc', cursor: 'pointer' }}
        >
          Try again
        </button>
      </body>
    </html>
  );
}
